/**
 * @fileoverview Main App component with routing
 */
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { PublicLayout } from '@/components/layout/PublicLayout';
import { WalletLayout } from '@/components/layout/WalletLayout';
import { ProtectedRoute, AdminRoute } from '@/components/common/ProtectedRoute';
const ExternalRedirect = ({ to }) => { window.location.replace(to); return null; };
import { LoginPage } from '@/pages/LoginPage';
import { DocumentsPage } from '@/pages/DocumentsPage';
import { IssueCertificatePage } from '@/pages/IssueCertificatePage';
import { MaintenancePage } from '@/pages/MaintenancePage';
import { HistoryPage } from '@/pages/HistoryPage';
import { StudentsPage } from '@/pages/StudentsPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { TemplatesPage } from '@/pages/TemplatesPage';
import { MyDocumentsPage } from '@/pages/MyDocumentsPage';
import { RegisterPage } from '@/pages/RegisterPage';
import { DocumentViewerPage } from '@/pages/DocumentViewerPage';
import { VerificationPage } from '@/pages/VerificationPage';
import { OTPPage } from '@/pages/OTPPage';
import { TenantManagement } from '@/pages/TenantManagement';
import { FileExplorerPage } from '@/pages/FileExplorerPage';
import { BlockchainDashboard } from '@/pages/BlockchainDashboard';
import { ContractManagerPage } from '@/pages/ContractManagerPage';
import { WalletHome } from '@/pages/wallet/WalletHome';
import { CertificateViewer } from '@/pages/wallet/CertificateViewer';
import { BeneficiariesPage } from '@/pages/BeneficiariesPage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<ExternalRedirect to="https://app.truedok.com/login" />} />
        <Route path="/home" element={<ExternalRedirect to="https://app.truedok.com/login" />} />
        <Route path="/login" element={<PublicLayout><LoginPage /></PublicLayout>} />
        <Route path="/register" element={<PublicLayout><RegisterPage /></PublicLayout>} />
        <Route path="/otp" element={<PublicLayout><OTPPage /></PublicLayout>} />
        <Route path="/verify" element={<PublicLayout><VerificationPage /></PublicLayout>} />
        <Route path="/forgot-password" element={<PublicLayout><ForgotPasswordPage /></PublicLayout>} />
        <Route path="/reset-password" element={<PublicLayout><ResetPasswordPage /></PublicLayout>} />

        {/* Certificate Wallet Routes - Standalone for role 'student' */}
        <Route path="/wallet" element={<WalletLayout>
          <ProtectedRoute>
            <WalletHome />
          </ProtectedRoute>
        </WalletLayout>} />
        <Route path="/wallet/certificate/:certId" element={<WalletLayout>
          <ProtectedRoute>
            <CertificateViewer />
          </ProtectedRoute>
        </WalletLayout>} />

        {/* Protected Routes - Recipients */}
        <Route path="/my-documents" element={<Layout>
          <ProtectedRoute>
            <MyDocumentsPage />
          </ProtectedRoute>
        </Layout>} />
        <Route path="/document/:documentId" element={<Layout>
          <ProtectedRoute>
            <DocumentViewerPage />
          </ProtectedRoute>
        </Layout>} />

        {/* Protected Routes - Plantillas (Admin only) */}
        <Route path="/templates" element={<Layout>
          <AdminRoute>
            <TemplatesPage />
          </AdminRoute>
        </Layout>} />

        {/* Protected Routes - Emitir Documentos (Admin only) */}
        <Route path="/courses" element={<Layout>
          <AdminRoute>
            <DocumentsPage />
          </AdminRoute>
        </Layout>} />

        {/* Protected Routes - Beneficiaries Management (Admin only) */}
        <Route path="/beneficiaries" element={<Layout>
          <AdminRoute>
            <BeneficiariesPage />
          </AdminRoute>
        </Layout>} />

        {/* Protected Routes - Panel de Mantenimiento (Admin only) */}
        <Route path="/maintenance" element={<Layout>
          <AdminRoute>
            <MaintenancePage />
          </AdminRoute>
        </Layout>} />

        {/* Protected Routes - Admin only */}
        <Route path="/history" element={<Layout>
          <AdminRoute>
            <HistoryPage />
          </AdminRoute>
        </Layout>} />
        <Route path="/students" element={<Layout>
          <AdminRoute>
            <StudentsPage />
          </AdminRoute>
        </Layout>} />
        <Route path="/settings" element={<Layout>
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        </Layout>} />
        <Route path="/files" element={<Layout>
          <AdminRoute>
            <FileExplorerPage />
          </AdminRoute>
        </Layout>} />
        <Route path="/admin/tenants" element={<Layout>
          <AdminRoute>
            <TenantManagement />
          </AdminRoute>
        </Layout>} />
        <Route path="/admin/blockchain" element={
          <AdminRoute>
            <BlockchainDashboard />
          </AdminRoute>
        } />
        <Route path="/admin/contract" element={
          <AdminRoute>
            <ContractManagerPage />
          </AdminRoute>
        } />

        {/* Redirect /dashboard to /courses */}
        <Route path="/dashboard" element={<Navigate to="/courses" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
